import '@ghost/lib/pagination.js'
import reframe from '@ghost/lib/vendor/reframe.min.js'
import '../css/index.css'
import './prism.js'
import Alpine from 'alpinejs'
import 'fslightbox'
import './main.js'
import dropdown from '../js/lib/dropdown'

document.addEventListener('alpine:initialized', async () => {
    const burger = document.querySelector('.gh-burger')
    if (!burger) return

    burger.addEventListener('click', function () {
        if (!document.body.classList.contains('is-head-open')) {
            document.body.classList.add('is-head-open')
        } else {
            document.body.classList.remove('is-head-open')
        }
    })

    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ]
    reframe(document.querySelectorAll(sources.join(',')))

    dropdown()
})

Alpine.data('lightboxImage', () => ({
    init() {
        this.$nextTick(() => {
            if (typeof FsLightbox.constructor !== 'function') {
                return
            }

            let lb = new window.FsLightbox()
            lb.sources = Array.from(
                document.querySelectorAll('a[data-fslightbox]')
            )
            lb.props.zoomIncrement = 0.5
            lb.props.showThumbsWithCaptions = true
        })
    },
}))

Alpine.data('nav', () => ({
    externalNavLinks: ['github', 'twitter', 'facebook'],
    init() {
        this.$nextTick(() => {
            for (let link of this.externalNavLinks) {
                const el = document.querySelector(`.nav-${link} > a`)
                if (!el) {
                    return
                }

                el.setAttribute('target', '_blank')
                // el.setAttribute('rel', 'noopener noreferrer')
            }
        })
    },
}))

Alpine.data('readingProgress', () => ({
    init() {
        this.$nextTick(() => {
            const progressBar = document.querySelector('.reading-progress')

            const updateProgress = () => {
                const position = window.scrollY
                const totalHeight = document.body.clientHeight
                const windowHeight = document.documentElement.clientHeight
                const progress = (position / (totalHeight - windowHeight)) * 100
                progressBar.setAttribute('value', progress)
                requestAnimationFrame(updateProgress)
            }

            if (progressBar) {
                requestAnimationFrame(updateProgress)
            }
        })
    },
}))

Alpine.start()


/**
 * Import JS
 * import menuOpen from './lib/menuOpen'
 * import infiniteScroll from './lib/infiniteScroll'
 */

// Call the menu and infinite scroll functions
// menuOpen()
// infiniteScroll()
